import React from 'react';

import { USER_ROLES, USER_STATES, USER_GENDERS } from 'utils/Constants';

import { Title } from 'components/Misc/Typography';
import { Avatar, Input, Select } from 'components/Misc/Form';

import { useUserCreateStore } from 'store/user/useUserCreateStore';

const Basic = () => {
	// Use user's creation store
	const [user, onChange] = useUserCreateStore(state => [
		state.user,
		state.onChange
	]);

	return (
		<div className="grid md:grid-cols-2 gap-4">
			<Title
				title="Pamatinformācija"
				className="md:col-span-2 text-xl"
			/>
			
			<Avatar
				name="avatar"
				label="Profila bilde"
				value={user.avatar}
				onChange={onChange}
				className="md:col-span-2"
			/>
			
			<Input
				type="text"
				name="name"
				label="Vārds"
				value={user.name}
				onChange={onChange}
			/>
			
			<Input
				type="text"
				name="surname"
				label="Uzvārds"
				value={user.surname}
				onChange={onChange}
			/>
			
			<Input
				type="text"
				name="personalCode"
				label="Personas kods"
				value={user.personalCode}
				onChange={onChange}
			/>
			
			<Select
				name="gender"
				label="Dzimums"
				placeholder=" "
				value={user.gender}
				onChange={onChange}
				options={USER_GENDERS}
			/>
			
			<Title
				title="Kontaktinformācija"
				className="md:col-span-2 text-xl"
			/>
			
			<Input
				type="email"
				name="email"
				label="E-pasts"
				value={user.email}
				onChange={onChange}
			/>
			
			<Input
				type="text"
				name="phoneNumber"
				label="Telefona numurs"
				value={user.phoneNumber}
				onChange={onChange}
			/>

			<Title
				title="Autorizācija"
				className="md:col-span-2 text-xl"
			/>
			
			<Select
				name="role"
				label="Grupa"
				value={user.role}
				onChange={onChange}
				options={USER_ROLES}
			/>
			
			<Select
				name="status"
				label="Statuss"
				value={user.status}
				onChange={onChange}
				options={USER_STATES}
			/>
		</div>
	);
};

export default Basic;
